<template>
  <div id="app">
      <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
    provide(){
        return{
            reload:this.reload
        }
    },
    data(){
        return {
            isRouterAlive:true,
        }
    },
    mounted() {
        //获取国际化语言
        this.getLangCoikieKey();
    },
    methods: {
        reload(){
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true
            });
        },
        getLangCoikieKey(){
            if (document.cookie.length>0) {
                var arr=document.cookie.split('; ');//这里显示的格式需要切割一下自己可輸出看下
                for(var i=0;i<arr.length;i++){
                    var arr2=arr[i].split('=');//再次切割
                    //判断查找相对应的值
                    if(arr2[0]=='langKey'){
                        this.langVal=arr2[1];
                        this.$i18n.locale = arr2[1];//关键语句
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss">

  body {
    margin: 0px;
    padding: 0px;
    background: url(assets/bg.png);
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    font-size: 12px;
    -webkit-font-smoothing: antialiased;
  }
  .pagination{
    margin-top: 15px;
    text-align: center;
	
	
  }
  .el-pagination__total{
      margin-top: 3px;
  }
  // 弹出界面大小
  .el-message-box
  {
	 width: 320px;
  }
  .el-pagination--small .btn-next, .el-pagination--small .btn-prev, .el-pagination--small .el-pager li, .el-pagination--small .el-pager li.btn-quicknext, .el-pagination--small .el-pager li.btn-quickprev, .el-pagination--small .el-pager li:last-child
  {
	height: 35px;     
  }
  .el-pagination{
    padding: 5px 0px;
    .btn-prev{
      height: 35px;
      border: 1px solid #ddd;
    }
	 
    ul{
      li{
        position: relative;
        margin-left: -1px;
         height: 35px;
        border: 1px solid #ddd;
        padding: 3px 4px;

      }
	 
	  .number
	  {
			height: 35px; 
			background-color: white;
	  }
      .active {
        background-color: #4B78FF;
        border: 1px solid #4B78FF;
        color: #fff;
		height: 35px;
		
      }
    }
    .btn-next{
      height: 35px;
      border: 1px solid #ddd;
      margin-left: -1px;
    }
  }
  .tabsbg{margin-bottom:14px;}
  .el-table .freeze-row {
    background: #C0C4CC;
  }
  /*
  .el-input__inner{
    width: 200px;
  }
  .el-input-number{
    width: 200px;
  }
  */
  .el-input--small .el-input__inner {
      /*border: 0.5px solid #000000;*/
  }
  /*.el-input__inner{border:1px solid #333 !important;}*/
   .el-input__inner{padding: 0 5px;color: #000000;text-align: left;}
   .el-textarea__inner{color: #000000;padding: 0 5px;}
   
   .el-form-item__label{color: #000000;}
   // .el-input.is-disabled .el-input__inner{
	  //  color: red;
   // }
   .el-table thead{color: white;}
   

   .el-button--warning{background-color:#4B78FF;border-color: #4B78FF;}
   .el-button--default{background-color:#4B78FF;border-color: #4B78FF;color: #fff;};
   .el-button--primary{color: #fff;background-color: #4B78FF;border-color: #4B78FF;}
  .el-button--primaryTwo{color: #fff;background-color: red;border-color: #4B78FF;}
    .el-button--info{background-color: #EEEEEE;color:#999999; border: 0px;}
   .el-button:hover{color: #fff;background-color: #4B78FF;border-color: #4B78FF;}
   .el-button:focus{color: #fff;background-color: #4B78FF;border-color: #4B78FF;}
   .el-pagination ul .active{color: #fff;background-color:#4B78FF;border-color:#4B78FF;}
   .el-switch__label.is-active{color: #4B78FF;}
   .el-switch.is-checked .el-switch__core{ border-color: #4B78FF;background-color: #4B78FF;}
  .el-table{font-size: 14px;color: #000000;}

  .el-table-column{background-color: red;}
  .el-table td, .el-table th{padding: 2px 0;}
  // .el-table tbody tr:hover>td { 
  //    // background-color:#ffffff!important
	 //  background-color:#4B78FF!important
  // }
  //鼠标经过表格背景色修改
  .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #4B78FF !important;
  color: white;
  }
    // .el-table tr:hover{background-color: red;}
  .el-dropdown-menu__item--divided {
       position: relative;
       margin-top: 6px;
       border-top: 0px solid #ebeef5;
  }
  .el-dropdown-menu
  {
	  border: 1px solid #4B78FF;
  }
  //修改操作悬浮背景色
   .el-dropdown-menu__item:hover
   {
	   background-color: #4B78FF !important;
	   color:white !important;
   }
  // .el-dropdown-item__item--divided:hover
  // {
	 //  background-color: red;
  // }
 //  .el-dropdown-item
 //  {
	// color: red;
 //  }
 
  
// .el-dropdown-item:hover{
        
//           background-color: #4B78FF !important;
//           color:#4B78FF !important;
//           //less语法，实现鼠标悬停时icon变色
        
//       }
  // .el-dropdown-menu__item:hover
  // {
	 //  background-color: red;
  // }
  // .el-dropdown-item
  // {
	 //  background-color: red;
  
  
  // .el-button:hover{color: #fff;background-color: #4B78FF;border-color: #4B78FF;}
  // .el-button:focus{color: #fff;background-color: #4B78FF;border-color: #4B78FF;}
  // .el-dropdown-item:hover{background-color: #4B78FF;}
  // .el-dropdown-item:focus{background-color: #4B78FF;}
  //ABC
  .el-button.is-circle {
      border-radius: 10%;
      padding: 12px;
  }
  .el-tag--medium {
      cursor: pointer;
  }
  .el-input__inner::-webkit-input-placeholder {
      color: #4B78FF;
  }
  .el-input.is-disabled .el-input__inner{color: #000000;}

  #login_from input{
      width: 100%;
      border: none;
      border-bottom: 1rpx solid #4B78FF ;
      background: none;
      color: #333;
      height: 50px;
      font-size: 16rpx;

  }
  #admin_font{float: right;}
  #changeLangEvent{
      text-align: center;
  }

  // .el-submenu .el-menu-item{height:48rpx;
  //     line-height: 48rpx;font-size:16rpx;width: 144px;}
  // el-submenu__title
  .el-menu-item, .el-submenu__title{height: 43.5px;line-height:43.5px;font-size:12px;text-align: left;}
  .el-submenu .el-menu-item {
      height: 35px;
       line-height: 30px;
      padding: 0 45px;
      min-width: 150px;
	  text-align: left;
	 margin-left: -8px;
  }
  .el-menu-item:hover{
    // background-color: red !important;
	color: #4B78FF !important;
  }
  
  //修改子菜單颜色
 .el-menu-item {
     background-color: #436DE2  !important;
	 
 }
 
  //菜單导航右箭头颜色
  .el-submenu__icon-arrow
  {
	  color: red;
	  margin-right: -10px;
  }
  .el-icon-arrow-down:before {
       content: "\E6DF";
      color: white;
  }
  // .el-submenu__title:hover{color:#fff;}
  // .el-submenu__title:hover i{color:#fff;}
// .right_box{
//     width: 68%;
//     float: left;
//     height: 70%;
//     margin-top: 13.7%;
//     -webkit-box-shadow: 11px 0px 20px 0px #4B78FF;
//     box-shadow: 11px 0px 20px 0px #cecece;
// }
  .el-autocomplete-suggestion{ width:auto !important;};
  .ind_cont table td{display: inherit;width:100%;height: 26px;padding-top: 3px;}

/* file 上傳控件样式    */
  .blueButton
  {
      position: absolute;
      display: block;
      width: 100px;
      height: 40px;
      background-color: #4B78FF;
      color: #fff;
      text-decoration: none;
      text-align: center;
      font:normal normal normal 16px/40px 'Microsoft YaHei';
      cursor: pointer;
      border-radius: 4px;
  }
  .blueButton:hover
  {
      text-decoration: none;
      cursor: pointer;
  }
  /*自定义上傳,位置大小都和a完全一样,而且完全透明*/
  .myFileUpload
  {
      position: absolute;
      display: block;
      width: 100px;
      height: 40px;
      opacity: 0;
      cursor: pointer;
  }
  /*显示上傳文件夹名的Div*/
  .show
  {
      position: absolute;
      top: 0px;
      width: 59%;
      height: 38px;
      font: normal normal normal 14px/30px 'Microsoft YaHei';
      right: 0px;
      overflow: hidden;
  }
  /* file 上傳控件样式    end  */

  #adjustFormRemark {min-height:90px!important;}

.mob_ser{    display: none;}


  h1, h2, h3, h4, h5, h6, p, dl, dt, dd { margin: 0; padding: 0; font-weight: normal; }

  body { font-family: Arial,"microsoft yahei"; font-size: 14px; margin: 0px; padding: 0px; color: #615f5f; line-height: 22px; height: auto; clear: both; background: #f4f4f4; }

  img { border: 0px; max-width: 100%;}

  ul, li { list-style: none; }

  em, i { font-style: normal; }

  a { text-decoration: none; color: #615f5f; outline: none; }

  a:hover { background-repeat: no-repeat; text-decoration: none;-webkit-transition: all 0.4s;
      -moz-transition: all 0.4s;
      -o-transition: all 0.4s;
      transition: all 0.4s; }

  a, area { blr: expression(this.onFocus=this.blur()); }

  .clearfix:after { visibility: hidden; display: block; font-size: 0; content: " "; clear: both; height: 0; }

  .clearfix { *zoom: 1; }

  .clear { clear: both; }

  * { webkit-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; }

  input, textarea, select { font-family: "微软雅黑"; outline: none; }

  .fl { float: left;font-size: 12px; }

  .fr { width: 400px; float:right;align-items: center;}
  // .fr div{display: inline;margin-left: 10px;width: 100px;}
  .fr span{font-size: 10.5px;margin-left: 5px;margin-top: 5px;}
    .wl{margin-left:10px;background:#A9EED1;color:#666666;border-radius:3px;float: left;width: 70px;height: 25px;}
  .kx{margin-left:10px;background:rgba(181,181,181,0.4);color:#666666;border-radius:3px;float: left;width: 70px;height: 25px;}
   .yd{margin-left:10px;background: rgba(255,57,77,0.1);color:#FF394D;border-radius:3px;float: left;width: 70px;height: 25px;}
    .yd img{float:right;margin-right: 5px;margin-top: 6px;}
	 .ed img{float:right;margin-right: 5px;margin-top: 6px;}
	.ed{margin-left:10px;background: rgba(55,127,252,0.2);color:#377FFC;border-radius:3px;float: left;width: 70px;height: 25px;}
  // .kx div{width: 200px;  }
  // .kx{background-color: red;font-size: 12px;width: 180px;}
  // .kx span{margin-left: 5px;}
  // .fr .kx{background-color: red;padding-left: 10px;width: 100px;height: 50px;}

  .row1 { text-overflow: ellipsis; -webkit-box-orient: vertical; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 1; }

  .row2 { text-overflow: ellipsis; -webkit-box-orient: vertical; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; }

  .row3 { text-overflow: ellipsis; -webkit-box-orient: vertical; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; }

  .commonweb { padding: 0px 10px; max-width: 1260px; margin: 0 auto; background: #fff; }

  .incommonweb { max-width: 1260px; margin: 0 auto; padding: 0; }

  .clear { clear: both; line-height: 0; height: 0; font-size: 0; }

  input[type="text"], input[type="password"], input[type="button"], input[type="submit"], select, textarea {outline-style: none; -webkit-appearance: none; resize: none;font-family: "Microsoft Yahei"; }

  * { -webkit-tap-highlight-color: transparent; tap-hightlight-color: transparent; touch-callout: none; -webkit-touch-callout: none; }
  body,HTML{WIDTH:100%;HEIGHT:100%;}
  body{
      font-family: "微软雅黑";
      background-position: center 0;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: cover;
      -webkit-background-size: cover;
      -o-background-size: cover;
      -moz-background-size: cover;
      -ms-background-size: cover;
  }
  .b_1{background:#4B78FF;color: #fff;height: 45px;}
  .search_1{
	  // position: absolute; 
	  //  right:-30px;
	  //  color:#f00;
	  //  top:-6px;
  }
  .search_2{
  	text-align: left;
	margin-left: 5px;
	
	
  }
  .pc_bg{width:100%;padding-bottom:30px;}
  .pc_main{width:100%;background: #f3f3f3;height:80%; margin:0 auto;}
  .header{ background: #fbfbfb;height:90px;border-bottom: 1px solid #c2c2c2; width: 100%}
  .head_left{width:56%;float:left;}
  .logo{float:left; margin-left:20px;}
  .logo a{width:150px;    display: inline-block;margin-top:8px;}
  .menu{ float: left; margin-left:10%;}
  .menu li{ float: left;padding:0 13px;}
  .menu li a{font-size:20px;line-height:90px;padding:0 20px; color: #4B78FF;}
  .menu li a:hover{ background: #4B78FF; display: inline-block; color:#fff;    }
  .menu li a.cur{ background: #4B78FF; display: inline-block; color:#fff;}
  .sec-btn{ display: none;}

  .search_btn{margin-right: 60px;float:right;}
  .search_btn div{float:left;position: relative;}
  .search_btn i{    margin-left: 20px;
      position: absolute;
      width: 30px;
      height: 30px;
      top: 36px;
      right: 5px;}
  .inp_sech{background: #eceff1;width:220px;height:33px;border-radius: 30px;padding:10px;margin-top:30px;color:#666;border: none; position: relative;}
  .setUp{width:44%;float: right;}
  .set_tx {background: #eceff1;margin-left:30px;position: relative; cursor: pointer;height:89px;float:right;padding-top:25px;padding-left:20px;padding-right:20px;}
  .set_tx span{width:40px;height:40px;border-radius:80px; background: #fff; overflow: hidden; display: inline-block; float: left;}
  .set_tx font{float: left; margin-top: 10px;margin-left: 10px;}

  .set_tx i.slide-icon {
      transition: All 0.4s ease-in-out;
      -webkit-transition: All 0.4s ease-in-out;
      -moz-transition: All 0.4s ease-in-out;
      -o-transition: All 0.4s ease-in-out;
  }
  .sec_icon{position: absolute;right: 10px;top: 6px;}
  .set_tx i{float: left;/*background: url(../img/icon.png);*/
      background-position: 0px -47px;
      display: inline-block;
      width: 11px;
      margin-top: 18px;
      margin-left: 5px;
      height: 7px;}

  #nav-header:hover i.slide-icon {
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
  }

  #nav-header .set_tx  .slide-submeu {position: absolute;right: 0;top: 89px;z-index: 1000;width: 100%;text-align: center;padding: 5px 0;background: #fff;border-top: 1px solid #E4E4E4;box-shadow: -1px 3px 5px rgba(000, 000, 000, 0.3); display: none;}
  #nav-header .set_tx:hover .slide-submeu {display: block;}
  .slide-submeu a{width:100%; line-height:40px; display: inline-block;}
  .slide-submeu a:hover{ background: #E4E4E4;}

  .ind_main{width:100%;height:100%;overflow: hidden; margin: 0 auto}
  .ind_txt{width:100%;font-size:20px; height:40px; overflow: hidden;width:105%;}
  .ind_txt span.bule{ color: #4B78FF;}
  .ind_txt span.red{color: #CA2620;}
  .tabs{width:94%;float:left;}
  .ind_cont{background: #f3f3f3; overflow: hidden; margin: 0 auto;width: 100%;height:100%;}
  .ind_cont table{ float: left;  background: #fff; font-weight:bold;}
 //homepagetable修改table td样式
  // .ind_cont table td{font-size: 5rem;}
  .ind_cont table td.cur{background: rgba(255,57,77,0.1);color:#FF394D; width:60px; margin: 10px;border-radius: 3px; }
  //搜索界面
  .ind_cont table td.searchcur{background: rgba(255,57,77,0.4);color:#FF394D; width: 60px;border-radius: 3px;clear: both;}
  .tabs table td img{float: right;margin-top: 5px;margin-right: 3px;};
  .ind_cont table td.curTwo{background: rgba(55,127,252,0.2);color:#377FFC;width:60px; margin: 10px;border-radius: 3px;}
  .ind_cont table td.curs{background: blue;color:#fff; width:60px; margin: 10px;border-radius: 3px;}
  .ind_cont table td.cur:hover{color:#FFFFFF; cursor: pointer; width:60px; margin: 10px;border-radius: 3px;}
    //搜索界面
	 .ind_cont table td.searchcur:hover{color:#FFFFFF; cursor: pointer; width: 60px;border-radius: 3px; }
	  
	.ind_cont table td.curTwo:hover{color:#FFFFFF; cursor: pointer; width:60px; margin: 10px;border-radius: 3px;}
  
   .ind_cont table td.curs:hover{color:#FFFFFF; cursor: pointer; width:60px; margin: 10px;border-radius: 3px;}
    .ind_cont table td.curThree:hover{color:#FFFFFF; cursor: pointer; width:60px; margin: 10px;border-radius: 3px;}
   
   .ind_cont table td.curThree{background: rgba(181,181,181,0.4);color:#666666;width:60px; margin: 10px;border-radius: 3px;}
   .ind_cont table td.curfour{background:white;color:#666666;width:60px; margin: 10px;border-radius: 3px;}

//物料
 .ind_cont table td.curFive{background: #A9EED1;color:#666666;width:60px; margin: 10px;border-radius: 3px;}
.ind_cont table td.curFive:hover{color:#FFFFFF; cursor: pointer; width:60px; margin: 10px;border-radius: 3px;}

.ind_cont table td span{margin-left: 5px; font-size: 10.5px;};
.tab_box table td img{float: right;margin-top: 5px;margin-right: 5px;};
  .table_qh{float: left;width:6%;height:100%; overflow:hidden;padding-top:40px;}
  .table_qh li{width:100%;height:30px; background: #e5e5e5;height:33%;width: 100%;text-align: center;border-bottom:1px solid #ccc;height: 30px;background: #e5e5e5;height: 33%;padding: 79px 0;font-size: 35px;padding-left:0px;}
  .table_qh li:hover{ background:#4B78FF; cursor: pointer;color:#fff;}
  .table_qh li.none{border:none;padding: 169px 0;}
  .table_qh li.cur{ background:#4B78FF; cursor: pointer;color:#fff;}
  .tongji{width:100%; overflow: hidden;}
  .tongji .fl_1{font-size:20px; font-weight: bold; float:left;width:24%; text-align: center;line-height:35px;}
  .tongji .fl_2{font-size:20px;font-weight: bold; float:left;width:35%; text-align: center;line-height:35px;margin:0 3%;}
  .tongji .fl_3{font-size:20px; font-weight: bold;float:left;width:35%; text-align: center;line-height:35px;}
  .tongji span.red{color: #CA2620;}
  .tab-item{ display: none;}
  .active{display: block; }
  .activeone{display: block; margin-top: 1%}

  .tab1{width:24%; background: #000;}
  .tab1 td{width:25%;}
 
  .tab2{width:35%; background: #000;margin:0 2%;}
  .tab2 td{width:12.3%;}
  .tab3{width:35%; background: #000;}
  .tab3 td{width:12.3%;}


  .ind_main2{width:100%;}
  .rk_cont{width:100%; border-bottom:1px solid #ddd; background: #ededed;}
  .ruku_top{ overflow: hidden;}
  .ruku_from{width:90%; margin:0.5rem auto;padding:0 5%;}
  .ruku_from ul{width:94%; margin: auto;}
  .ruku_from li{width:40%;margin-bottom:1rem;}
  .ruku_from li span{ float: left;line-height:40px;font-size:20px; text-align: center;}
  .ruku_from li span.w2{letter-spacing:0.5em;margin-right:-0.5em;}
  .ruku_from li span.w3{letter-spacing:2em;margin-right:-2em;}
  .ruku_from li input.rk_inp1{width:80%; border:1px solid #ccc; float: left;height:40px;margin-left:3%; font-size:18px; text-indent:0.5rem;}

  .pc_main2 .ind_cont{ background:none;}


  // .ruku_list{margin-top:2%;}
  table.responsive{width: 100%;margin: 0 auto;border-collapse: collapse;background: #f3f3f3;word-break: break-word !important;font-size: 12px;}
 // table.responsive tr{line-height:1.8rem; background: #4B78FF;color:#fff;}
  // table.responsivetr t{line-height:1.8rem; background: #4B78FF;color:#fff;};
  table.responsive th,table.responsive td{font-size:1.2rem;padding: 0.5em 0.5em;text-align: center;}
  .rk_btn {width:100%; text-align: center;margin-top:2rem;}
  .rk_btn a{background: #4B78FF;color:#fff;padding:10px 30px;font-size:20px; display:inline-block;}
  .rk_btn a:hover{background: #0f49a9; cursor: pointer;}

  .rk_btn2 { text-align: center;margin-top:2rem; float: right; overflow: hidden;margin-right:2%; margin-bottom:1rem;}
  .rk_btn2 a{background: #4B78FF;color:#fff;padding:10px 30px;font-size:20px; display:inline-block;}
  .rk_btn2 a:hover{background: #0f49a9; cursor: pointer;}

  .page{width:100%; text-align: center;margin:2rem 0 0 0;}
  .page li{display: initial;}
  .page li a{ display: inline-block;padding:10px 20px; background: #e7e7e7;margin-right:5px;font-size:16px;}

  .page li a:hover{background: #4B78FF;color:#fff;}


  /*隐藏掉我们模型的checkbox*/
  .my_protocol .input_agreement_protocol {
      appearance: none;
      -webkit-appearance: none;
      outline: none;
      display: none;
  }
  /*未选中时*/
  .my_protocol .input_agreement_protocol+span {
      width: 35px;
      height: 33px;
      background-color: red;
      display: inline-block;
     /* background: url(../img/icon_checkbox.jpg) no-repeat;*/
      background-position-x: 0px;
      background-position-y: 0px;
      position: relative;
      top: 3px;
  }
  /*选中checkbox时,修改背景图片的位置*/
  .my_protocol .input_agreement_protocol:checked+span {
      background-position: 0 -33px
  }

  .kehu_list{width:100%; overflow: hidden;    margin-top: 1%;}
  .kehu_list ul{padding: 0px;      margin: 0px;      overflow: hidden;      margin-right: -2rem;}
  .kehu_list li{float:left;width:47%; margin-right: 1rem; margin-bottom: 1rem;}
  .kehu_list li:hover table{ background: #eee;cursor: pointer;}
  .kehu_list table{width:100%; background: #fff;border:1px solid #bbb;border-bottom:none;margin-top: 0%;}
  .kehu_list table td{border-bottom:1px solid #bbb;line-height:45px;font-size:18px;}
  .kehu_list table td.b_1{text-align: center;font-size:26px;line-height:55px;position: relative;}


  .yg_list{width:96%; margin: 0 auto; overflow: hidden;}
  .yg_list table{width:100%;background: #fff;border:1px solid #ddd;}

  .yg_list table td,.yg_list table th{font-size:16px; border-bottom: 1px solid #ddd;padding:1rem 1rem; text-align: center;border-right:1px solid #ddd;}
  .yg_list table th{ font-size:18px; font-weight: bold;border-bottom: 1px solid #ddd;padding:1.2rem 1rem;}
  .yg_list a.bj_btn{padding:10px 20px;background: #4B78FF;color:#fff;}

  .kehu_list2 li{width:100%;border-right:1px solid #ddd;margin-left:0px;}
  .kehu_list2 li:hover table{background: #fff;}

  .kehu_list3 ul{padding: 0px;      margin: 0px;      overflow: hidden;  margin-right: 0rem;}

  .sch_btn{ margin-top: 2rem;}
  .sbtn a{padding:10px 20px;  background: #4B78FF;color:#fff;font-size:1rem;}
  .sbtn button {padding:10px 20px;  background: #4B78FF;color:#fff;font-size:1rem;}


.xinz button{float:right;}
.ruku_list table{margin-bottom: 1rem;}
.quanxuan_box{margin-bottom:0.5rem; overflow: hidden;}
.quanxuan_box input{width:20px; height: 20px; float: left;}
.quanxuan_box label{ line-height:25px; float: left;}
  .el-dialog{width:82%;}
 .el-dialog__body{padding:20px;}
  @media only screen and (max-width: 1919px){
      .logo a{width:137px; display: inline-block; margin-top: 10px;}
      .menu li a{font-size:18px;}
      .search_btn{margin-left:60px;float: right;}
      .set_tx{margin-left:19px;}
      .ind_txt{font-size:18px;}
  }



  @media only screen and (max-width: 1680px){
      .logo a{width:130px; display: inline-block; margin-top: 10px;}
      .menu li a{font-size:18px;}
      .search_btn{margin-left:60px;}
      .search_btn span{ margin-left: 22px;}
      .ind_txt{font-size:18px;}
      .table_qh li{font-size:30px;}
      .ind_cont table td{font-size:16px;}
      .ruku_from li input.rk_inp1{width:70%; }
  }
  @media only screen and (max-width: 1440px){
      .search_btn{margin-left:3%;}
      .menu li{padding:0 6px;}
      .menu{    width: 68%;}
      .kehu_list table td{font-size:16px;}
      .kehu_list table td.b_1{font-size:24px;line-height:65px;}

  }

  @media only screen and (max-width: 1366px){

      .menu{margin-left:10%;}
      .menu li{padding:0 5px;}
      .menu li a{font-size:16px;}
      .search_btn{margin-left:2%;}
      .search_btn span{ margin-left: 20px;}
      .inp_sech{width:210px;}
      .table_qh li{font-size:26px;}
      .set_tx span{width:30px;height:30px;margin-top:8px;}
      .kehu_list table td{font-size:14px;line-height: 45px;}
      .kehu_list table td.b_1{font-size:24px;line-height:55px;}
  }
  @media only screen and (max-width: 1366px){
      .inp_sech{width:200px;}
  }

  @media only screen and (max-width: 1280px){
      .inp_sech{width:180px;}
      .logo a{width:140px;margin-top: 10px;}
      .menu{margin-left:4%;}
      .search_btn{margin-right:40px;}
  }
  @media only screen and (max-width: 1280px){
      .search_btn{margin-right:20px;}

      .ruku_from li{width:45%;margin-left:5%;}
      .ruku_from li input.rk_inp1{width:65%;}
      .page li a{ display: inline-block;padding:5px 10px; background: #e7e7e7;margin-right:5px;font-size:16px;}
  }
  @media only screen and (max-width: 1024px){
      .ind_cont table td{height:24px;}
      .table_qh li{padding:88px 0;}
  }

  @media only screen and (max-width:1023px){
      .header{width:100%;height:70px;-moz-box-shadow:0px 4px 7px #ddd; -webkit-box-shadow:0px 14px 7px #ddd; box-shadow:0px 4px 7px #ddd;}
      .logo a{width:100px;}
      .table_qh{padding-top:20px;}
      .set_tx{display: none;}
      .tab1,.tab2,.tab3{display:none;}
      .tongji{width:100%;}
      .tongji div{float: left; width:50%;padding:160px 0;color:#333;border-bottom:1px solid #ccc;-moz-box-shadow:0px 4px 7px #ddd; -webkit-box-shadow:0px 14px 7px #ddd; box-shadow:0px 4px 7px #ddd;font-size:1.6rem;}
      .tongji .fl_1{width:25%; background:#ffdbbd;}
      .tongji span.red{color:red;}

      .tongji .fl_2{width:50%; margin: 0px;  background:#bddaff;}
      .tongji .fl_3{width:25%; background:#ffbdbd;}
      .ind_txt .fr{width:100%; float: left; }
      .table_qh{width:100%;margin-top: 0; margin-bottom:0.6rem;-moz-box-shadow:0px 3px 4px #ddd; -webkit-box-shadow:0px 3px 4px #ddd; box-shadow:0px 3px 4px #ddd;}
      .table_qh li{width:33.3%; float: left;padding:1rem 0; border-right:1px solid #ccc;}
      .table_qh li.none{padding:1rem 0; border-bottom: 1px solid #ccc;}
      .ind_txt{font-size:16px;}
      .tabs{width:100%;}
      .ind_txt{margin:0 0 0.8rem 0;}
      .inp_sech{ margin-top:17px;margin-right:2.8rem;}
      .inp_sech2{display: block;margin-top:10px;}
      .search_btn i{right:2.8rem;top:23px;}
      .sec-box{display: none;}
      .sec-btn{position: absolute;right:0.8rem;top:19px;
          display: block;
          background: none;
          transition: 0.3s all;
          -webkit-transition: 0.3s all;
          border: none;
          width: 30px;
          padding: 0;
          outline: none;
          float: right;
          z-index: 99;
      }
      .sec-btn em {
          display: block;
          width: 100%;
          height: 4px;
          background: #4B78FF;
          margin-top: 4px;
          border-radius: 5px;
          -webkit-transition: 0.3s;
          -moz-transition: 0.3s;
          -ms-transition: 0.3s;
      ;
          transition: 0.3s;
          position: relative;
      }
      .sec-btn.slide em {
          height: 3px
      }
      .sec-btn.slide em.em1 {
          top: 12px;
          -webkit-transform: rotate(45deg);
          -moz-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          -o-transform: rotate(45deg);
          transform: rotate(45deg);
      }
      .sec-btn.slide em.em2 {
          opacity: 0;
          -webkit-transform: rotate(-90deg);
          -moz-transform: rotate(-90deg);
          -ms-transform: rotate(-90deg);
          -o-transform: rotate(-90deg);
      }
      .sec-btn.slide em.em3 {
          top: -3px;
          -webkit-transform: rotate(-45deg);
      }
      .sec-box {
          position: absolute;
          top:70px;
          left: 0;
          right: 0;
          width: 100%;
          background: #f7f7f7;
          color: #333;

      }
	  ///手机端样式
	  .banckFont
	  {
		color: #333333;
		 font-size: 16px;
		font-weight: bold; 
	  }
      .page li {}
      .page li a{font-size:12px;margin-right: 2px;}

      .menu li{width:100%; text-align: center;border-bottom:1px solid #ccc; }
      .menu li a{line-height:3rem; width: 100%; display: inline-block;}
      table.responsive{width:100%;background-color:white;color: #333333;}
	  //手机端客戶全部庫存
	   table.responsive,table.responsive tr th, table.responsive tr td { border:1px solid #F9F8F8; }
      table.responsive th{width:15%;}
      .ruku_from{width:100%;padding-left:5%;}
      .ruku_from ul{width:100%;}
      .ruku_from li{margin-left:0px;}
      .ruku_from li input.rk_inp1{width:71%;}
      .kehu_list li{width:100%;margin-left:0px;margin-bottom:1rem;}

      .kehu_list table td{font-size:14px;line-height: 35px;}
      .kehu_list table td.b_1{font-size:20px;line-height:45px;}
      .yg_list table td,.yg_list table th{font-size:12px;padding:0.5rem 0}
      .yg_list table th{ font-size:12px; font-weight: bold;border-bottom: 1px solid #ddd;padding:0.8rem 0}
      .yg_list a.bj_btn{padding:5px 10px;background: #4B78FF;color:#fff;}
      .rk_btn2{margin-top: 0px;}
      .rk_btn2 a{padding:0.5rem 1rem; font-size:1rem;}

      .menu-expanded{display:none;}
      .tools{    position: absolute;right: 1em;}
      .logo{margin-left:0px;}

      #admin_font span{margin-right:100px;}
	    #phoneAdmin_font span{margin-right:100px;}
		#phoneAdmin_font{position: absolute;top: 0px;display: inline-block;width: 100%;left: -40px;}
	  .el-icon-arrow-down:before{color: black;}
      #admin_font {position: absolute;top: 0px;display: inline-block;width: 100%;left: -40px;}
      .header .el-col-16{width:auto;}
      .menu-collapsed{width:100% !important;position: absolute; z-index: 99;}
      .menu-collapsed ul{width:100%;}
      .sec_icon{position: absolute;right: 19px;top:-45px;width: 30px; height: 30px;
          z-index:9999;}
      .none{ display: none;}

      .inp_sech2{background: #eceff1;width:220px;height:40px;border-radius: 10px;padding:10px;color:#666;border: none;position: absolute;right:30px;}
      .mob_ser{width: 100%;position: absolute;background: #4B78FF; height: 59px;top: 92px; z-index: 999; }
      .ss_btn{height:40px;padding:0 15px; background: #000;color:#fff; text-align: center;position: absolute;top:10px;border-radius: 10px;right:12px;line-height: 40px;}
       // .el-button+.el-button {margin: 50px; }
      .sbtn button {    font-size: 0.75rem;padding: 10px 10px;}

      .mob_tongji{width:100%;}


      .mob_tjTxt{float:left;width:100%; overflow: hidden;margin-bottom: 15px}
      .mob_tjTxt div{background: #dadada;float:left;padding:60px 0px; text-align: center;font-size:1rem;}
      .mob_tjTxt .fl_0{width:13%; background: #4B78FF;color:#fff;float:left;margin-right:5px;}
      .mob_tjTxt .fl_1{width:30%;}
      .mob_tjTxt .fl_2{width:37%;margin: 0 5px;}
      .mob_tjTxt .fl_3{width:29%;}

  }






  @media only screen and (max-width: 479px) {


      .fr{float:left;color:#4B78FF;}
      .ruku_from li span{width:100%;font-size:16px; text-align:left;}
      .ruku_from li {width:50%;margin:0;}
      .ruku_from li input.rk_inp1{margin-left:0;width:90%;font-size:14px;}
      .ruku_from {margin:0px;padding: 0 0 0 4%;}
      table.responsive th, table.responsive td{font-size:14px;}
      .sec_icon{top:-45px;}
  }


//   .el-select-dropdown__list{padding-left: 10px;}
  @media only screen and (max-width: 340px) {

      .container .header .logo img {
          width:90px !important;
          padding-top:18px;
      }

  }

  @media all and (max-width: 1024px) and  (orientation : landscape){
      .ind_cont table td{height:24px;}
      .table_qh li{padding:88px 0;}
  }




</style>



// WEBPACK FOOTER //
// src/App.vue